<h1 id="list-item-2">
    <marquee scrolldelay="80">
      <pre>الأطفال الأبطال      الأطفال الأبطال      الأطفال الأبطال      الأطفال الأبطال      الأطفال الأبطال      الأطفال الأبطال      الأطفال الأبطال      الأطفال الأبطال</pre>
    </marquee>
    <marquee direction="right" scrolldelay="80">
      <pre>الأطفال الأبطال      الأطفال الأبطال      الأطفال الأبطال      الأطفال الأبطال      الأطفال الأبطال      الأطفال الأبطال      الأطفال الأبطال      الأطفال الأبطال</pre>
    </marquee>
  </h1>
  
  <div class="Container">
    <img src="../../assets/photos/intoduction.jpg" class="image">
    <div class="fadedbox">
      <div class="title Text">
        علاوة على إهمالهم من قبل المجتمع والحكومة اللبنانية، يتحمل الأطفال ذوو الاحتياجات الخاصة في الوقت الراهن عواقب
        جائحة كوفيد ١٩ التي اجتاحت العالم والأزمات المتراكمة التي طالت لبنان. فهم يواجهون الكثير من التراجع في
        المهارات وغياب التحفيز على صعيد الصحة العقلية. نهدي هذه القصة للأطفال الذين يكافحون وللعائلات التي تناضل وحيدة في
        بلد منهار لتذكيرهم بقوتهم ولمنحهم جرعة من الأمل في وسط الأوضاع المأساوية التي نمر بها اليوم.
      </div>
    </div>
  </div>